// Team Service exports — endpoint definitions live in @trackly/shared (createTeamApi); this
// instantiates the single web-authenticated instance and re-exports its hooks so existing
// importers across Trackly.WebClient are unaffected by the shared-package extraction.
import { teamApi } from './teamApiBase';

export { teamApi };
export const { useGetTeamByIdQuery, useGetTeamsQuery, useGetActiveTeamsQuery, useUpsertTeamMutation } = teamApi;
export { createDefaultTeam } from './team';
export type { TeamView, TeamListView, TeamMemberView, TeamUpsertRequest, TeamGetByIdParams, TeamsListRequest } from '@trackly/shared';